import { PropertyListBlock } from "../../../types";
import ImmobillienAngebot from "@/components/Landingpage/ImmobillienAngebot";

interface PropertyListProps {
  block: PropertyListBlock;
}

export default function PropertyList({ block }: PropertyListProps) {
  return <ImmobillienAngebot title={block.title} />;
}
